import React from 'react';
import { cx } from './cx';

export interface KeyValueItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Stronger value text (totals). */
  emphasis?: boolean;
  /** The one bonus that is added, or the final amount the player receives. */
  tone?: 'bonus' | 'result';
  /** Full-width content under the row, such as the offers inside a bonus. */
  details?: React.ReactNode;
}

export interface KeyValueListProps {
  items: KeyValueItem[];
  className?: string;
}

/** Label/value rows on the inset surface (summaries, limits, details). */
export default function KeyValueList({ items, className }: KeyValueListProps) {
  return (
    <dl className={cx('m-0 flex flex-col overflow-hidden rounded-control border border-edge-subtle bg-inset', className)}>
      {items.map((it, i) => (
        <div
          key={i}
          className={cx(
            'border-t border-edge-subtle first:border-t-0',
            it.tone === 'bonus' && 'border-action-primary/28 bg-action-primary/12',
            it.tone === 'result' && 'bg-raised'
          )}
        >
          <div className={cx('flex items-baseline justify-between gap-3 px-3', it.tone === 'result' ? 'py-3' : 'py-2.5')}>
            <dt
              className={cx(
                'min-w-0 font-ui text-small text-secondary',
                it.tone === 'bonus' && 'font-semibold text-amount-in',
                it.tone === 'result' && 'text-body font-semibold text-primary'
              )}
            >
              {it.label}
            </dt>
            <dd className={cx('m-0 text-right font-ui text-small text-primary', (it.emphasis || it.tone === 'bonus' || it.tone === 'result') && 'font-semibold')}>
              {it.value}
            </dd>
          </div>
          {it.details}
        </div>
      ))}
    </dl>
  );
}
